module.exports = __webpack_public_path__ + "img/google-maps.18c6fc99.svg";